<!--
 * @Date: 2023-12-15 11:46:08
 * @Author: jm
 * @LastEditTime: 2024-02-28 14:37:38
 * @LastEditors: jm
 * @FilePath: \funny_h5\src\components\GamesMore.vue
 * @Description: 
-->
<template>
  <div class="content">
    <div class="title">
      <div class="t-left">
        <span class="line"></span>
        <span class="icon">{{ leftIcon }}</span>
      </div>
      <a :href="`type.html?type=${leftText}`" v-if="leftText !== ''">
        <img src="@/assets/images/more_wenzi.png" alt="" class="wenzi" />
      </a>
    </div>
    <slot name="content"> </slot>
  </div>
</template>

<script>
export default {
  name: "GamesMore",
  props: {
    leftIcon: {
      type: String,
      required: true,
    },
    leftText: { type: String, required: false, default: "" },
  },
};
</script>

<style lang="scss" scoped>
.content {
  width: 100%;
  margin: 18px 0px 0px;
  .title {
    width: 1000px;
    height: 110px;
    margin: 0 auto;
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #ffffff;
    .t-left {
      display: flex;
      align-items: center;
      .line {
        width: 15px;
        height: 80px;
        background: #ff6464;
        margin-right: 24px;
      }
      .icon {
        font-size: 50px;
        font-weight: bold;
        color: #ffffff;
      }
    }
    .wenzi {
      width: 123px;
      height: 40px;
    }
  }
}
</style>
